import {Component, Input, OnInit} from '@angular/core';
import { HelpersService } from 'src/app/services/helpers/helpers.service';

@Component({
  selector: 'app-banner-blue',
  templateUrl: './banner-blue.component.html',
  styleUrls: ['./banner-blue.component.scss']
})
export class BannerBlueComponent implements OnInit {
    @Input() data: any
  constructor(private helpers: HelpersService) {}
  
    ngOnInit(): void {}
    
    removeLangFromRoute(url: any) {
      return this.helpers.removeLangFromRoute(url)
    }

}
